/*
  GLBOAL
  forged by Andrew Vink
  Copyright
*/

// Open ALL External Links in new Tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

// document.querySelectorAll('.product__accordion details').forEach(details => {
//   details.querySelector('summary').addEventListener('click', function(event) {
//       // Close all details elements
//       document.querySelectorAll('.product__accordion details').forEach(item => {
//           if (item !== details) {
//               item.removeAttribute('open');
//           }
//       });
//   });
// });


/*
  ACCORDION - Vanilla JavaScript 2025
  forged by Andrew Vink
*/
document.addEventListener('DOMContentLoaded', function() {
  const accordionTitles = document.querySelectorAll('.accordion-title');

  accordionTitles.forEach(title => {
    title.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const content = this.nextElementSibling;
      const isOpen = this.classList.contains('open');

      if (!isOpen) {
        // Close all other accordions
        accordionTitles.forEach(otherTitle => {
          otherTitle.classList.remove('open');
          const otherContent = otherTitle.nextElementSibling;
          if (otherContent && otherContent.classList.contains('accordion-content')) {
            otherContent.style.maxHeight = null;
          }
        });

        // Open this accordion
        this.classList.add('open');
        if (content && content.classList.contains('accordion-content')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      } else {
        // Close this accordion
        this.classList.remove('open');
        if (content && content.classList.contains('accordion-content')) {
          content.style.maxHeight = null;
        }
      }
    });
  });
});


/*
  COOKIE PREFERENCES
  A link to #cookie-preferences reopens Shopify's cookie banner at its preferences. Matched by its
  href because the page editor keeps links, so the Cookie Policy page can use one.
*/
document.addEventListener('click', function(e) {
  const trigger = e.target.closest('a[href$="#cookie-preferences"]');
  if (!trigger || !window.privacyBanner) return;

  e.preventDefault();
  window.privacyBanner.showPreferences();
});
